import React from "react";
import PropTypes from "prop-types";
import { Icon } from "@qgiv/core-react";
import { ReceiptDetailHeading, Divider } from "@qgiv/core-donor";
import ConnectedReceiptStoreItem from "./ConnectedReceiptStoreItem";
import ConnectedReceiptSubtotal from "./ConnectedReceiptSubtotal";

const ReceiptDetailsStore = ({
    formattedShippingAmount,
    formattedTaxAmount,
    controlId,
    cart,
    hasShippingMethod,
    isVisible = false,
    shippingMethodName,
    shippingMethodDescription,
    taxRate,
    totalCost,
    subtotalLabel,
    storeSubsectionHeading,
    shippingLabel,
    taxLabel,
}) =>
    isVisible && (
        <>
            <div className="col col--12">
                <ReceiptDetailHeading>
                    <Icon
                        className="-type--regular -font-weight--bold -margin-right--10"
                        glyph="shopping-cart-solid"
                        type="FontAwesome"
                    />
                    <strong>{storeSubsectionHeading}</strong>
                </ReceiptDetailHeading>
            </div>

            {cart.map((item, i) => (
                <ConnectedReceiptStoreItem
                    // eslint-disable-next-line react/no-array-index-key
                    key={i}
                    id={i}
                    controlId={controlId}
                />
            ))}

            {hasShippingMethod && (
                <>
                    <div className="col col--12 col--no-top-gutter">
                        <div className="grid">
                            <div className="col col--8">
                                <p>{shippingLabel}</p>

                                <p className="-margin-top--0">
                                    <small>{`${shippingMethodName} (${shippingMethodDescription})`}</small>
                                </p>
                            </div>
                            <div className="col col--4 -text--right">
                                <p>{formattedShippingAmount}</p>
                            </div>
                        </div>
                    </div>

                    <Divider dashed />
                </>
            )}

            {formattedTaxAmount && (
                <>
                    <div className="col col--12 col--no-top-gutter">
                        <div className="grid">
                            <div className="col col--8">
                                <p>{`${taxLabel} ${taxRate}%`}</p>
                            </div>
                            <div className="col col--4 -text--right">
                                <p>{formattedTaxAmount}</p>
                            </div>
                        </div>
                    </div>

                    <Divider dashed />
                </>
            )}

            <div className="col col--12 col--no-top-gutter">
                <ConnectedReceiptSubtotal
                    total={totalCost}
                    subtotalLabel={subtotalLabel}
                />
            </div>
        </>
    );

ReceiptDetailsStore.propTypes = {
    formattedShippingAmount: PropTypes.string.isRequired,
    formattedTaxAmount: PropTypes.string.isRequired,
    hasShippingMethod: PropTypes.bool.isRequired,
    cart: PropTypes.arrayOf(PropTypes.shape).isRequired,
    shippingMethodDescription: PropTypes.string.isRequired,
    shippingMethodName: PropTypes.string.isRequired,
    taxRate: PropTypes.number.isRequired,
    totalCost: PropTypes.number.isRequired,
    subtotalLabel: PropTypes.string.isRequired,
    storeSubsectionHeading: PropTypes.string.isRequired,
    shippingLabel: PropTypes.string.isRequired,
    taxLabel: PropTypes.string.isRequired,
    isVisible: PropTypes.bool.isRequired,
    controlId: PropTypes.number.isRequired,
};

export default ReceiptDetailsStore;
